import { UserManager, WebStorageStateStore } from 'oidc-client';
import { getIdentityConfig, getMetaDataOIDC } from '../utils/AuthUtils';
import { getApis } from '../library/Apis';

export const LOCAL_STORAGE_ID_TOKEN = 'id_token';
export const LOCAL_STORAGE_ACCESS_TOKEN = 'access_token';
export const LOCAL_STORAGE_REDIRECT_URI = 'redirectUri';

export const getToken = () => {
  const token = window.localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN);
  return typeof token === 'string' ? token : null;
};

export const isAuthenticated = () => {
  const access_token = window.localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN);
  return !!access_token;
};

class AuthService {
  UserManager;
  props;

  constructor(props) {
    this.props = props;
    this.UserManager = new UserManager({
      ...getIdentityConfig(),
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      metadata: {
        ...getMetaDataOIDC(),
      },
    });
  }

  toRedirect = (newPath) => {
    this.props.history.push(newPath);
  };

  signinRedirectCallback = () => {
    this.UserManager.signinRedirectCallback();
  };

  signinRedirect = () => {
    if (window.location.hash) {
      const access_token = window.location.hash.substring(
        window.location.hash.indexOf('=') + 1,
        window.location.hash.indexOf('&')
      );
      if (access_token) {
        window.localStorage.setItem(LOCAL_STORAGE_ACCESS_TOKEN, access_token);
        const id_token = window.location.hash.substring(
          window.location.hash.indexOf('id_token=') + 9,
          window.location.hash.indexOf('&token_type')
        );
        window.localStorage.setItem(LOCAL_STORAGE_ID_TOKEN, id_token);
        const redirectUri = localStorage.getItem(LOCAL_STORAGE_REDIRECT_URI);
        if (redirectUri) {
          this.toRedirect(redirectUri);
          localStorage.removeItem(LOCAL_STORAGE_REDIRECT_URI);
          return;
        }
      }
    }
    localStorage.setItem(LOCAL_STORAGE_REDIRECT_URI, window.location.pathname);
    this.UserManager.signinRedirect({});
  };

  logout = () => {
    let logoutUrl;
    new Promise((resolve, reject) => {
      const idTken = localStorage.getItem(LOCAL_STORAGE_ID_TOKEN);
      const redirectUri = localStorage.getItem(LOCAL_STORAGE_REDIRECT_URI);
      if (idTken) {
        logoutUrl =
          getApis()
            .auth.wso2LogoutUrl.split('#1#')
            .join(window.localStorage.getItem(LOCAL_STORAGE_ID_TOKEN)) +
          getApis().auth.logofRedirectUrl;
        window.localStorage.clear();
        window.localStorage.setItem(LOCAL_STORAGE_REDIRECT_URI, redirectUri);
        this.UserManager.clearStaleState()
          .then(() => {
            resolve();
          })
          .catch(() => {
            resolve();
          });
      } else {
        reject();
      }
    }).then(
      () => {
        window.location.href = logoutUrl;
      },
      () => {
        window.location.href = getApis().auth.redirectUrl;
      }
    );
  };
}

export default AuthService;
